/**
 * MotoRava delivery estimate: replaces the day-range fallbacks with real
 * dates counted forward from today in working days.
 */
class MrDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    const dispatch = Number(this.dataset.dispatch) || 0;
    const min = Number(this.dataset.min) || 0;
    const max = Math.max(Number(this.dataset.max) || 0, min);
    const skipWeekend = this.dataset.skipWeekend === 'true';

    const locale = document.documentElement.lang || undefined;
    const format = new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'short' });
    const today = new Date();

    /** @param {number} days */
    const addWorkingDays = (days) => {
      const date = new Date(today);
      let added = 0;
      while (added < days) {
        date.setDate(date.getDate() + 1);
        const day = date.getDay();
        if (skipWeekend && (day === 0 || day === 6)) continue;
        added += 1;
      }
      return date;
    };

    /** @param {string} key @param {string} text */
    const set = (key, text) => {
      const el = this.querySelector(`[data-eta="${key}"]`);
      if (el) el.textContent = text;
    };

    set('ordered', format.format(today));
    set('dispatched', format.format(addWorkingDays(dispatch)));
    const from = format.format(addWorkingDays(min));
    const to = format.format(addWorkingDays(max));
    set('delivered', min === max ? from : `${from} – ${to}`);
  }
}

if (!customElements.get('mr-delivery-estimate')) {
  customElements.define('mr-delivery-estimate', MrDeliveryEstimate);
}
